import { render, staticRenderFns } from "./ConfirmColleges.vue?vue&type=template&id=37012ebc&scoped=true"
import script from "./ConfirmColleges.vue?vue&type=script&lang=js"
export * from "./ConfirmColleges.vue?vue&type=script&lang=js"
import style0 from "./ConfirmColleges.vue?vue&type=style&index=0&id=37012ebc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37012ebc",
  null
  
)

export default component.exports